import {
  BasePriceKeyListMap,
  getPlatformContentLabelI18n
} from '@/interface/common';
import { getYouTubeContentTypeLabel } from '@/biz/youtubeContentTypeLabel';
export { formatSingleBraceTemplate } from '@/utils/formatSingleBraceTemplate';

export const getCreatorPlacementContentTypeLabel = ({
  platform,
  contentType,
  t
}: {
  platform?: string;
  contentType?: string;
  t: (key: string) => string;
}) => {
  if (!contentType) return '';
  const youtubeLabel = getYouTubeContentTypeLabel({
    platform,
    contentType,
    t,
    includePlatform: true
  });
  if (youtubeLabel) return youtubeLabel;
  const canonicalPlatform = String(platform ?? '')
    .trim()
    .toLowerCase();
  const canonicalContentType =
    BasePriceKeyListMap[canonicalPlatform]?.[contentType] ?? contentType;
  return getPlatformContentLabelI18n(canonicalContentType, t) ?? contentType;
};

/**
 * Platform-free delivery labels. YouTube shares the long-form names used by
 * quote cards; other platforms retain their compact delivery labels.
 */
export const getCreatorDeliveryContentTypeLabel = ({
  platform,
  contentType,
  t
}: {
  platform?: string;
  contentType?: string;
  t?: (key: string, options: { defaultValue: string }) => string;
}) => {
  const canonicalPlatform = String(platform ?? '')
    .trim()
    .toLowerCase();
  const canonicalContentType = String(contentType ?? '')
    .trim()
    .toLowerCase();

  if (canonicalPlatform === 'youtube') {
    return getYouTubeContentTypeLabel({
      platform: canonicalPlatform,
      contentType: canonicalContentType.includes('integrated')
        ? 'Integrated video'
        : 'Dedicated video',
      t
    })!;
  }
  if (canonicalPlatform === 'tiktok') return 'Video';
  if (canonicalPlatform === 'instagram') return 'Reel';
  return contentType || '';
};
